import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class GetInstantOfferByAdSellerService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Function} deps.adsEntityFactory
   * @param {GetCurrentUserService} deps.getCurrentUserService
   * @param {Function} deps.invalidRequestErrorFactory
   * @param {HTTPSellerRepository} deps.repository
   * @param {Function} deps.userNotLoggedInErrorFactory
   */
  constructor({
    adsEntityFactory,
    getCurrentUserService,
    invalidRequestErrorFactory,
    repository,
    userNotLoggedInErrorFactory
  }) {
    super()

    this._adsEntityFactory = adsEntityFactory
    this._getCurrentUserService = getCurrentUserService
    this._invalidRequestErrorFactory = invalidRequestErrorFactory
    this._repository = repository
    this._userNotLoggedInErrorFactory = userNotLoggedInErrorFactory
  }

  @inlineError
  execute({adId, simulate} = {}) {
    if (!adId) return Promise.reject(this._invalidRequestErrorFactory())

    const adEntity = this._adsEntityFactory({id: adId})

    return this._getCurrentUserService
      .execute()
      .then(userEntity => {
        if (!userEntity)
          return Promise.reject(
            this._userNotLoggedInErrorFactory({
              message: 'To get an instant offer you must be logged in'
            })
          )
        return this._repository.getInstantOfferByAd({
          adEntity,
          userEntity,
          simulate
        })
      })
      .then(([error, instantOfferVO]) => (error ? Promise.reject(error) : instantOfferVO))
  }
}
